<template src="./MainPage.html"></template>

<script>
import Logo from './Logo';

export default {
  components: {
    Logo,
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/vars.scss";
@import "~styles/logo_animations.scss";

.main{
  background-color: $blue;
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  @media only screen and (max-width : $phone){
    position: absolute;
    top: 0;
  }
}

.main_content{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.main_img{
  width: 45vw;
  height: 30vw;
  min-width: 400px;
  min-height: 350px;
  background-size: contain;
  background-position: top center;
  background-repeat: no-repeat;

    @media only screen and (max-width : $tablet){
      width: 660px;
      height: 515px;
      margin-top: -35px;
    }

    @media only screen and (max-width : $phone){
      width: 97vw;
      height: 75vw;
      margin-top: 0;
      min-width: auto;
      min-height: auto;
    }
}

.main_text{
  display: block;
  margin-top: 20px;
  opacity: 0;
  animation: fadeIn 1s ease-out forwards;
  animation-delay: 1s;

  @media only screen and (max-width : $tablet){
    opacity: 1;
    animation: none;
  }

  @media only screen and (max-width : $phone){
    margin-top: 9.375vw;
  }
}

.main_title{
  font-family: $playfair;
  font-size: 44px;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 12px;

  @media only screen and (max-width : $phone){
    font-size: 9.375vw;
    letter-spacing: 2.5vw;
  }
}

.main_subtitle{
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 4px;
  margin-top: 15px;

  @media only screen and (max-width : $phone){
    font-size: 2.5vw;
    letter-spacing: 0.9375vw;
    margin-top: 2.6875vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mainpage/MainPage.vue